import { atom } from "recoil";

// KP全医療機関マスタの医療機関健保の中間テーブル
export const hospitalInsuranceState = atom({
  key: "hospitalInsuranceState",
  default: {
    id: null,
    hospital_id: null,
    insurance_id: null,
    insurance_name: '',
    notes: '',
  },
});